import React from 'react';
import { ArrowLeft, Shield, FileText, Mail } from 'lucide-react';

const LegalPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        <button 
          onClick={onBack} 
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-6 font-medium transition"
        >
          <ArrowLeft size={18}/> Retour
        </button>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-3xl font-bold text-slate-900 mb-8 flex items-center gap-3">
            <Shield className="text-blue-600" size={32}/>
            Mentions Légales
          </h1>

          {/* ÉDITEUR DE LA PLATEFORME */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FileText size={20} className="text-blue-600"/>
              Éditeur de la plateforme
            </h2>
            <div className="bg-slate-50 p-6 rounded-xl space-y-2 text-sm text-slate-700">
              <p><strong>Nom :</strong> Ovrio</p>
              <p><strong>Forme juridique :</strong> Auto-entrepreneur</p>
              <p><strong>Capital social :</strong> 1000 euros</p>
              <p><strong>Siège social :</strong> 19 Avenue du Général de Gaulle 11170 Pezens</p>
              <p><strong>SIRET :</strong> 93016212800019</p>
              <p><strong>N° TVA intracommunautaire :</strong> Non Applicable</p>
              <p><strong>Email :</strong> contact@ovrio.fr</p>
              <p><strong>Directeur de la publication :</strong> BIENFAIT Jérome</p>
            </div>
          </section>

          {/* HÉBERGEUR */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">Hébergement</h2>
            <div className="bg-slate-50 p-6 rounded-xl space-y-2 text-sm text-slate-700">
              <p><strong>Hébergeur :</strong> Firebase (Google Cloud Platform)</p>
              <p><strong>Société :</strong> Google LLC</p>
              <p><strong>Adresse :</strong> 1600 Amphitheatre Parkway, Mountain View, CA 94043, États-Unis</p>
              <p><strong>Site web :</strong> <a href="https://firebase.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">firebase.google.com</a></p>
            </div>
          </section>

          {/* PROTECTION DES DONNÉES */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">Protection des données personnelles (RGPD)</h2>
            <div className="space-y-4 text-sm text-slate-700">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, 
                de rectification, de suppression et d'opposition au traitement de vos données personnelles.
              </p>
              
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                <h3 className="font-bold text-slate-800 mb-2">Données collectées</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Informations d'inscription (nom, prénom, email)</li>
                  <li>Informations d'entreprise (nom, adresse, SIRET, etc.)</li>
                  <li>Données clients (coordonnées, devis, factures)</li>
                  <li>Données de connexion et logs d'activité</li>
                </ul>
              </div>

              <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                <h3 className="font-bold text-slate-800 mb-2">Utilisation des données</h3>
                <p>
                  Vos données sont utilisées uniquement pour le fonctionnement de la plateforme : 
                  gestion de votre compte, création de devis et factures, envoi d'emails professionnels.
                  Nous ne vendons ni ne partageons vos données avec des tiers.
                </p>
              </div>

              <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
                <h3 className="font-bold text-slate-800 mb-2">Conservation des données</h3>
                <p>
                  Vos données sont conservées pendant toute la durée de votre abonnement et jusqu'à 
                  [X années] après la fermeture de votre compte, conformément aux obligations légales comptables.
                </p>
              </div>

              <p className="flex items-center gap-2 text-slate-600 mt-4">
                <Mail size={16}/>
                Pour exercer vos droits, contactez-nous à : <strong>contact@ovrio.fr</strong>
              </p>
            </div>
          </section>

          {/* PROPRIÉTÉ INTELLECTUELLE */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">Propriété intellectuelle</h2>
            <div className="space-y-3 text-sm text-slate-700">
              <p>
                L'ensemble des contenus présents sur Ovrio (textes, graphiques, logos, icônes, images, logiciels) 
                est la propriété exclusive de Ovrio ou de ses partenaires.
              </p>
              <p>
                Toute reproduction, distribution, modification ou publication non autorisée de ces éléments est strictement interdite.
              </p>
              <p className="font-semibold text-blue-600">
                Vous conservez la propriété complète de vos données (clients, devis, factures) et pouvez les exporter à tout moment.
              </p>
            </div>
          </section>

          {/* COOKIES */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-800 mb-4">Cookies</h2>
            <div className="space-y-3 text-sm text-slate-700">
              <p>
                Ovrio utilise des cookies strictement nécessaires au fonctionnement de la plateforme 
                (authentification, session utilisateur).
              </p>
              <p>
                Nous n'utilisons pas de cookies publicitaires ou de tracking tiers.
              </p>
            </div>
          </section>

          {/* CONTACT */}
          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4">Contact</h2>
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-200">
              <p className="text-sm text-slate-700 mb-3">
                Pour toute question concernant ces mentions légales ou vos données personnelles :
              </p>
              <div className="flex flex-col gap-2 text-sm">
                <p><strong>Email :</strong> <a href="mailto:contact@ovrio.fr" className="text-blue-600 hover:underline">contact@ovrio.fr</a></p>
                <p><strong>Téléphone :</strong> 07.62.16.36.49</p>
                <p><strong>Adresse :</strong> 19 Avenue du Général de Gaulle 11170 Pezens</p>
              </div>
            </div>
          </section>

          {/* MENTION LÉGALE RGPD */}
          <div className="mt-8 pt-6 border-t border-slate-200 text-xs text-slate-500">
            <p>
              Dernière mise à jour : Décembre 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
